import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { Link } from "../../../components/Link";
import Header from "../../../components/Header";

const LOCATIONS = [
  {
    img: "/images/around-us/locations/bomras",
    title: "Bomras",
    distance: 10,
    category: "Restaurant",
    mapsUrl: "https://maps.app.goo.gl/PUytamrBEjuwbhi68",
  },
  {
    img: "/images/around-us/locations/jolene",
    title: "Jolene",
    distance: 12,
    category: "Restaurant",
    mapsUrl: "https://maps.app.goo.gl/h1eVRJ8tsFcPJJnC7",
  },
  {
    img: "/images/around-us/locations/slow-tide",
    title: "Slow Tide",
    distance: 8,
    category: "Restaurant",
    mapsUrl: "https://maps.app.goo.gl/CoWcL2PKyx4NxkyQ6",
  },
  {
    img: "/images/around-us/locations/elephant-co",
    title: "Elephant & Co.",
    distance: 7,
    category: "Cafe",
    mapsUrl: "https://maps.app.goo.gl/88Jy9bgvxsZTCiyw7",
  },
  {
    img: "/images/around-us/locations/baba-au-rhum",
    title: "Baba Au Rhum",
    distance: 9,
    category: "Cafe",
    mapsUrl: "https://maps.app.goo.gl/t8wjSPZ12zHC7rpaA",
  },
  {
    img: "/images/around-us/locations/artjuna",
    title: "Artjuna",
    distance: 6,
    category: "Cafe",
    mapsUrl: "https://maps.app.goo.gl/1PS2KoCqkZ6BxBUL7",
  },
  {
    img: "/images/around-us/locations/thalassa",
    title: "Thalassa",
    distance: 15,
    category: "Nightclub",
    mapsUrl: "https://maps.app.goo.gl/S9m9yBU4FAZTSooh6",
  },
  {
    img: "/images/around-us/locations/anjuna-markets",
    title: "Anjuna Flea Market",
    distance: 5,
    category: "Night Market",
    mapsUrl: "https://maps.app.goo.gl/PZWnffdkiBPxpcSC7",
  },
  {
    img: "/images/around-us/locations/anjuna",
    title: "Anjuna Beach",
    distance: 6,
    category: "Beach",
    mapsUrl: "https://maps.app.goo.gl/bnDD7qEVVzer7zYr5",
  },
  {
    img: "/images/around-us/locations/morjim",
    title: "Morjim Beach",
    distance: 30,
    category: "Beach",
    mapsUrl: "https://maps.app.goo.gl/CqmyX1u3X8UGFPa9A",
  },
  {
    img: "/images/around-us/locations/vagator",
    title: "Vagator Beach",
    distance: 9,
    category: "Beach",
    mapsUrl: "https://maps.app.goo.gl/tdoTSiqfAJ3eC7aG8",
  },
  {
    img: "/images/around-us/locations/siolim",
    title: "Uddo Beach",
    distance: 21,
    category: "Beach",
    mapsUrl: "https://maps.app.goo.gl/6g2kmf8517mnHkQy6",
  },
];

const Locations = () => {
  return (
    <Box maxWidth={1000} mx="auto" mt={16} mb={24} px={1}>
      <Header label="Trending" title="Popular locations around us" />
      <Grid
        container
        columns={{ xs: 3, sm: 6, md: 9, lg: 12 }}
        spacing={4}
        mt={4}
        data-aos="fade-up"
      >
        {LOCATIONS.map(({ img, title, distance, category, mapsUrl }, idx) => {
          return (
            <Grid idx={idx} item xs={3} data-aos="fade-up" data-aos-delay={idx * 50}>
              <Link
                url={mapsUrl}
                component={
                  <Stack position="relative">
                    {/* Image with overlay container */}
                    <Box
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        aspectRatio: "1/1",
                      }}
                    >
                      <picture>
                        <source srcSet={`${img}.webp`} type="image/webp" />
                        <img
                          src={`${img}.png`}
                          alt="Background"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </picture>
                      {/* Gradient Overlay */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background:
                            "linear-gradient(to bottom left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))",
                        }}
                      />
                    </Box>

                    {/* Category Badge */}
                    <Stack
                      bgcolor={"#2998FA"}
                      borderRadius={100}
                      px={1}
                      pt={0.5}
                      sx={{
                        position: "absolute",
                        top: { xs: 24, sm: 12 },
                        right: { xs: 24, sm: 12 },
                      }}
                    >
                      <Typography
                        variant="body2"
                        typography={{ xs: "body1", sm: "body2" }}
                        sx={{ fontSize: 12 }}
                        fontWeight={500}
                      >
                        {category}
                      </Typography>
                    </Stack>

                    {/* Text Section */}
                    <Stack mt={2} alignItems="start" gap={0}>
                      <Typography
                        variant="h6"
                        typography={{ xs: "h5", sm: "h6" }}
                      >
                        {title}
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="text.secondary"
                      >
                        {distance} minutes away
                      </Typography>
                    </Stack>
                  </Stack>
                }
              />
            </Grid>
          );
        })}
      </Grid>
      <Box m="auto" width="fit-content" mt={12} data-aos="fade-up" data-aos-delay={300}>
        <Link
          url="https://www.conciergedegoa.com"
          component={
            <Button variant="contained" color="white" size="large">
              See more locations
            </Button>
          }
        />
      </Box>
    </Box>
  );
};

export default Locations;
